import type { AudioVideoFacade, AudioVideoObserver, DataMessage } from 'amazon-chime-sdk-js'
import { ECG_TOPIC, HDStethEcgTransport } from './ecg-stream'

/** Chime rejects realtime data messages above 2 KB. */
export const CHIME_DATA_MESSAGE_MAX_BYTES = 2048

/** Accept ECG only from the configured source in the dedicated stethoscope meeting. */
export function createChimeEcgTransport(audioVideo: AudioVideoFacade, sourceUserId?: string): HDStethEcgTransport {
  return {
    send: (message) => {
      const payload = JSON.stringify(message)
      if (new TextEncoder().encode(payload).length > CHIME_DATA_MESSAGE_MAX_BYTES) return
      try { audioVideo.realtimeSendDataMessage(ECG_TOPIC, payload, 0) } catch { /* Drop packets during reconnects. */ }
    },
    subscribe: (listener) => {
      const receive = (message: DataMessage): void => {
        if (!sourceUserId || message.senderExternalUserId !== sourceUserId || message.throttled || message.data.byteLength > CHIME_DATA_MESSAGE_MAX_BYTES) return
        try { listener(JSON.parse(message.text()) as unknown) } catch { /* Ignore malformed messages. */ }
      }
      const observer: AudioVideoObserver = { audioVideoDidStop: () => listener(null), audioVideoDidStartConnecting: () => listener(null) }
      const presence = (_attendeeId: string, present: boolean, externalUserId?: string): void => {
        if (!present && externalUserId === sourceUserId) listener(null)
      }
      audioVideo.realtimeSubscribeToReceiveDataMessage(ECG_TOPIC, receive)
      audioVideo.realtimeSubscribeToAttendeeIdPresence(presence)
      audioVideo.addObserver(observer)
      return () => {
        audioVideo.realtimeUnsubscribeFromReceiveDataMessage(ECG_TOPIC)
        audioVideo.realtimeUnsubscribeToAttendeeIdPresence(presence)
        audioVideo.removeObserver(observer)
      }
    },
  }
}
